<template>
  <div class="tc-box" v-if="show" @click="show = false">
  	<div class="tc-box-model" @click.stop>
  		<div class="tc-box-model-top">
  			<div class="tc-box-model-top-div"></div>
  			<div class="tc-box-model-top-title">{{$t('all.tishi')}}</div>
			<img src="../../assets/image/wode_jiazu@2x.png" alt="" @click="show = false"/>
  		</div>
		<div class="tc-box-model-center" v-if="data == 1">{{$t('all.quedingtuichudengluma')}}</div>
		<div class="tc-box-model-bottom" @click="logout" v-if="data == 1">{{$t('all.queding')}}</div>
		
		<div class="tc-box-model-center" v-if="data == 0">{{$t('all.quedingqudengluma')}}</div>
		<div class="tc-box-model-bottom" @click="login" v-if="data == 0">{{$t('all.queding')}}</div>
  	</div>
  </div>
</template>

<script>
import { checkIsLogin } from "@/api/zhibo";
export default {
  data() {
    return {
	  show:false,
	  data:-1
    };
  },
  mounted() {
	
  },
  methods: {
	//判断是否登录
	async checkIsLogin(){
		const res = await checkIsLogin()
		this.data = res.data
		this.show = true
	},
	showModel(){
		this.checkIsLogin()
	},
    //退出登录
	logout(){
		this.$router.replace('/login');
		sessionStorage.setItem('user', null);
		this.$store.commit('changeToken', null); 
		this.$store.commit('changeUserId', null); 
		this.$store.commit('changeUserInfo', null);
		setTimeout(() => {
			window.history.pushState(null, null, '/login');
			window.addEventListener('popstate', () => {
			window.history.pushState(null, null, '/login');
			});
		}, 100);
	},
	//登录
	login(){
	  this.$router.replace('/login');
		// 核心：禁止浏览器返回（永久生效）
	  setTimeout(() => {
	    window.history.pushState(null, null, '/login');
	    window.addEventListener('popstate', () => {
	      window.history.pushState(null, null, '/login');
	    });
	  }, 100);
	}
  }
};
</script>
<style scoped lang="scss">
	@import "./tuichudenglu.css";
</style>


// WEBPACK FOOTER //
// tuichudenglu.vue?cdb68e44